// Firebase Cloud Messaging Configuration File. 
// Read more at https://firebase.google.com/docs/cloud-messaging/js/client && https://firebase.google.com/docs/cloud-messaging/js/receive

import axios from 'axios';
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

var firebaseConfig = {
  apiKey: "AIzaSyCq5l57tKjFJkpx6mlBUxJCdO_aUAI0eEU",
  authDomain: "cpsturnitin.firebaseapp.com",
  projectId: "cpsturnitin",
  storageBucket: "cpsturnitin.appspot.com",
  messagingSenderId: "994987528038",
  appId: "1:994987528038:web:3b5d7f3a867581f2ccc2a7"
};

initializeApp(firebaseConfig);

const messaging = getMessaging();

export const requestForToken = (userId) => {
  return getToken(messaging, { vapidKey: `BDuvCWTiuzHjg7gJR_l5bITeVSNTmw4mQ-wJ_Ysx18OfFlrRs0sLpih_9yHWgffGetbO6MpEN_Lkw3BP-_JZFfA` })
    .then((currentToken) => {
      if (currentToken) {
        axios({
          method: 'post',
          url: process.env.REACT_APP_MY_VAR+"/api/createFCMToken",
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          credentials: 'same-origin',
          data: {
            token:currentToken,
            user_id:userId
          },
        })
      } else {}
    })
    .catch((err) => {});
};

// Handle incoming messages. Called when:
// - a message is received while the app has focus
// - the user clicks on an app notification created by a service worker `messaging.onBackgroundMessage` handler.
// Handle incoming messages with a callback
export const onMessageListener = (callback) => {
  onMessage(messaging, (payload) => {
    callback(payload);
  });
};

  
